module.exports = __webpack_public_path__ + "static/media/wallet-connect.d1f73612.svg";